import React, { Component } from "react";
import { observer, inject } from "mobx-react";


class MultipleChoice extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            checked: [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ]
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {}

    handleChange(e: any, i: number, selectedAnswer: string) {
        this.props.setSelectedAnswer(selectedAnswer);
        const tempChecked = this.state.checked.map((_checked: boolean, index: number) => index === i);
        this.setState({
            checked: tempChecked
        });
    }

    render() {
        return (
            <div>
                <div className="question-type-header">Multiple Choice</div>
                {this.props.optionalContext && this.props.optionalContext.length > 0 ? (
                    <div className="optional-context">{this.props.optionalContext}</div>
                ) : (
                    <span></span>
                )}
                <div className="question-text">{this.props.text}</div>
                <br />
                <fieldset className="multiple-choice-options">
                <legend className="sr-only">Choose one answer</legend>
                {this.props.question.choices.map(
                    (choice: any, i: number) => {
                        return (
                            <label className="multiple-choice-option" key={`${choice.slug}-${i}`}>
                                <input
                                    type="radio"
                                    name="answerChoices"
                                    value={choice.slug}
                                    checked={this.state.checked[i]}
                                    onChange={(e: any) => this.handleChange(e, i, choice.slug)}
                                />
                                <span>{choice.title}</span>
                            </label>
                        );
                    }
                )}
                </fieldset>
            </div>
        );
    }
}

export default observer(MultipleChoice);
